import React from 'react';
import { decode } from 'html-entities';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import dictData from 'dictionary';

interface IProps {
  title?: string;
  description?: string;
  imageURL?: string;
  contentDescription?: string;
}

const HelmetComponent: React.FC<IProps> = ({ title, description, imageURL, contentDescription }) => {
  const url = useLocation();

  return (
    <Helmet titleTemplate={`%s - ${dictData.helmet.default_title}`} defaultTitle={`${dictData.helmet.default_title}`}>
      <html lang="pl" />
      {title && <title>{decode(title)}</title>}
      <meta name="description" content={description ? description : dictData.helmet.default_description} />
      <meta property="og:title" content={`${dictData.helmet.default_title} - ${title}`} />
      <meta property="og:image" content={imageURL ? imageURL : dictData.helmet.default_img} />
      <meta
        property="og:description"
        content={contentDescription ? contentDescription : dictData.helmet.default_description}
      />
      <meta property="og:url" content={url.pathname} />
      <meta name="twitter:card" content="summary" />
      <meta property="twitter:url" content={url.pathname} />
      <meta property="twitter:title" content={`${dictData.helmet.default_title} - ${title}`} />
      <meta
        property="twitter:description"
        content={contentDescription ? contentDescription : dictData.helmet.default_description}
      />
      <meta property="twitter:image" content={imageURL ? imageURL : dictData.helmet.default_img} />
    </Helmet>
  );
};

export default HelmetComponent;
